/* Wishlist — saved in the browser, no account needed.
 *
 * Loaded from sections/header.liquid so it is present on every page: the heart
 * buttons live on product pages, the counter lives in the header, and the grid
 * lives on the wishlist page.
 *
 * Storage: localStorage key fi:wishlist, an array of { handle, added }.
 * Product data is read from /products/<handle>.js at render time, so titles,
 * prices and stock are never stale and nothing is duplicated into storage.
 */
(function () {
  if (window.FIWishlist) return;

  var KEY = 'fi:wishlist';
  var listeners = [];

  function read() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (item) {
        return item && typeof item.handle === 'string' && item.handle;
      });
    } catch (e) {
      return []; /* private mode or corrupt value: behave as empty */
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* Storage full or blocked — the page still reflects the change in memory. */
    }
    listeners.forEach(function (fn) {
      fn(items);
    });
  }

  function has(handle) {
    return read().some(function (item) {
      return item.handle === handle;
    });
  }

  function add(handle) {
    if (!handle || has(handle)) return false;
    var items = read();
    items.unshift({ handle: handle, added: new Date().toISOString() });
    write(items);
    return true;
  }

  function remove(handle) {
    var items = read();
    var kept = items.filter(function (item) {
      return item.handle !== handle;
    });
    if (kept.length === items.length) return false;
    write(kept);
    return true;
  }

  window.FIWishlist = {
    all: read,
    count: function () {
      return read().length;
    },
    has: has,
    add: add,
    remove: remove,
    toggle: function (handle) {
      return has(handle) ? (remove(handle), false) : (add(handle), true);
    },
    subscribe: function (fn) {
      listeners.push(fn);
      return fn;
    }
  };

  /* ---------- settings, read off the header link so they stay editable ---------- */

  function setting(name, fallback) {
    var host = document.querySelector('[data-fi-wishlist-link]');
    var value = host && host.getAttribute('data-' + name);
    return value || fallback;
  }

  /* ---------- notification ---------- */

  function toast(message, variant) {
    if (!message) return;
    var host = document.querySelector('.fi-wl-toasts');
    if (!host) {
      host = document.createElement('div');
      host.className = 'fi-wl-toasts';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }

    var node = document.createElement('div');
    node.className = 'fi-wl-toast' + (variant ? ' fi-wl-toast--' + variant : '');
    node.textContent = message;
    host.appendChild(node);

    window.requestAnimationFrame(function () {
      node.classList.add('is-in');
    });

    window.setTimeout(function () {
      node.classList.remove('is-in');
      window.setTimeout(function () {
        if (node.parentNode) node.parentNode.removeChild(node);
      }, 400);
    }, 3200);
  }

  /* ---------- buttons ---------- */

  function paintButtons() {
    var buttons = document.querySelectorAll('[data-fi-wishlist]');
    Array.prototype.forEach.call(buttons, function (button) {
      var saved = has(button.getAttribute('data-product-handle'));
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = button.getAttribute(saved ? 'data-label-saved' : 'data-label-add');
      if (label) button.setAttribute('aria-label', label);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fi-wishlist]');
    if (button) {
      event.preventDefault();
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      var added = window.FIWishlist.toggle(handle);
      if (added) {
        toast(setting('added-text', 'Added to wishlist successfully'));
      } else {
        toast(setting('removed-text', 'Removed from wishlist'), 'removed');
      }
      return;
    }

    var removeButton = event.target.closest('[data-fi-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(removeButton.getAttribute('data-fi-wishlist-remove'));
      toast(setting('removed-text', 'Removed from wishlist'), 'removed');
      return;
    }

    /* Buy Now: same route as the product page — add, then straight to checkout. */
    var buyButton = event.target.closest('[data-fi-wl-buy]');
    if (buyButton) {
      event.preventDefault();
      var variantId = buyButton.getAttribute('data-fi-wl-buy');
      if (!variantId || buyButton.getAttribute('aria-disabled') === 'true') return;

      buyButton.setAttribute('aria-disabled', 'true');
      buyButton.classList.add('loading');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window
        .fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          /* A status means the add was refused, so checkout would be pointless. */
          if (result && result.status) {
            toast(result.description || result.message, 'removed');
            buyButton.removeAttribute('aria-disabled');
            buyButton.classList.remove('loading');
            return;
          }
          window.location.href = root + 'checkout';
        })
        .catch(function () {
          window.location.href = root + 'cart';
        });
    }
  });

  /* ---------- add to basket, into the theme's cart drawer ---------- */

  /* cart-drawer and cart-notification both expose getSectionsToRender/renderContents,
     so whichever the shop is set to is handed the response and opens itself. With
     the cart set to "page" there is neither, and the form posts normally. */
  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.fi-wl-card form');
    if (!form) return;

    var cart = cartComponent();
    if (!cart || typeof cart.renderContents !== 'function') return; /* let it post */

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (button) {
      if (button.getAttribute('aria-disabled') === 'true') return;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }

    var body = new FormData(form);
    body.append(
      'sections',
      cart.getSectionsToRender().map(function (section) {
        return section.id;
      })
    );
    body.append('sections_url', window.location.pathname);

    window
      .fetch(form.getAttribute('action') || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        /* Shopify returns a status only when the add failed. */
        if (response.status) {
          toast(response.description || response.message, 'removed');
          return;
        }

        if (typeof cart.setActiveElement === 'function' && button) cart.setActiveElement(button);
        cart.classList.remove('is-empty');
        cart.renderContents(response);

        /* Keeps the theme's cart listeners — and the add-on guard — in step. */
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'fi-wishlist',
            productVariantId: body.get('id'),
            cartData: response
          });
        }
      })
      .catch(function () {
        /* Network trouble: fall back to the plain post so the shopper is not stuck. */
        form.submit();
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      });
  });

  /* ---------- header counter ---------- */

  function paintCount() {
    var total = window.FIWishlist.count();

    var nodes = document.querySelectorAll('[data-fi-wishlist-count]');
    Array.prototype.forEach.call(nodes, function (node) {
      node.textContent = total;
      var bubble = node.closest('[data-fi-wishlist-bubble]') || node;
      bubble.hidden = total === 0;
    });

    /* "3 items saved" on the wishlist page. */
    var totals = document.querySelectorAll('[data-fi-wishlist-total]');
    Array.prototype.forEach.call(totals, function (node) {
      var template = node.getAttribute(total === 1 ? 'data-one' : 'data-many') || '';
      node.textContent = template.replace('[count]', total);
      node.hidden = total === 0 || !template;
    });
  }

  /* ---------- wishlist page ---------- */

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return String(format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':
          return withCommas + '.' + parts[1];
        case 'amount_no_decimals':
          return withCommas;
        case 'amount_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default:
          return match;
      }
    });
  }

  function card(product, grid) {
    var format = grid.getAttribute('data-money-format');
    var image = product.featured_image
      ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2')
      : null;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        variant = product.variants[i];
        break;
      }
    }

    var item = document.createElement('li');
    item.className = 'fi-wl-card';

    var removeLabel = grid.getAttribute('data-remove-label') || 'Remove';
    var media =
      '<div class="fi-wl-card__media-wrap">' +
      (image
        ? '<a class="fi-wl-card__media" href="' +
          product.url +
          '" tabindex="-1" aria-hidden="true"><img src="' +
          image +
          '" alt="" loading="lazy" width="600" height="600"></a>'
        : '') +
      '<button type="button" class="fi-wl-card__x" data-fi-wishlist-remove="' +
      product.handle +
      '" aria-label="' +
      removeLabel +
      '" title="' +
      removeLabel +
      '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">' +
      '<line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>' +
      '</button>' +
      '</div>';

    var priceHtml = '<span class="fi-wl-card__now">' + money(product.price, format) + '</span>';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      /* Both figures come from the product, so the saving is calculated, not claimed. */
      var off = Math.round(
        ((product.compare_at_price - product.price) / product.compare_at_price) * 100
      );
      priceHtml +=
        '<s class="fi-wl-card__was">' +
        money(product.compare_at_price, format) +
        '</s>' +
        (off > 0
          ? '<span class="fi-wl-card__save">' +
            (grid.getAttribute('data-save-label') || 'Save [percent]%').replace('[percent]', off) +
            '</span>'
          : '');
    }

    var showAdd = grid.getAttribute('data-show-add') === 'true';
    var showBuy = grid.getAttribute('data-show-buy') === 'true';
    var actions = '';

    if (!variant && (showAdd || showBuy)) {
      actions =
        '<p class="fi-wl-card__sold-out">' +
        (grid.getAttribute('data-sold-out-label') || 'Sold out') +
        '</p>';
    } else if (variant) {
      if (showAdd) {
        actions +=
          '<form action="' +
          (grid.getAttribute('data-cart-url') || '/cart/add') +
          '" method="post" enctype="multipart/form-data">' +
          '<input type="hidden" name="id" value="' +
          variant.id +
          '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="button button--full-width fi-wl-card__add">' +
          (grid.getAttribute('data-add-label') || 'Add to Basket') +
          '</button></form>';
      }
      if (showBuy) {
        actions +=
          '<button type="button" class="button button--full-width button--secondary fi-wl-card__buy" data-fi-wl-buy="' +
          variant.id +
          '">' +
          (grid.getAttribute('data-buy-label') || 'Buy Now') +
          '</button>';
      }
      if (actions) actions = '<div class="fi-wl-card__actions">' + actions + '</div>';
    }

    item.innerHTML =
      media +
      '<div class="fi-wl-card__body">' +
      '<a class="fi-wl-card__title" href="' +
      product.url +
      '">' +
      product.title +
      '</a>' +
      '<div class="fi-wl-card__price">' +
      priceHtml +
      '</div>' +
      actions +
      '</div>';

    return item;
  }

  /* ---------- "You May Also Like" on the wishlist page ----------
     Shopify's recommendations need a product to recommend against, and a page
     template has none. The saved handles alone are not enough either — the
     endpoint wants a numeric id. renderGrid already fetches /products/<handle>.js
     for every item, and that response carries the id, so the seed costs no extra
     request: the newest saved product (add() unshifts, so index 0) becomes the
     one recommendations are drawn from.

     sections/related-products.liquid renders the marker attributes and starts the
     section hidden. */
  function seedRecommendations(products) {
    var host = document.querySelector('product-recommendations[data-fi-wishlist-seed]');
    if (!host) return;

    var section = host.closest('[data-fi-wishlist-recommendations]');

    var seed = null;
    for (var i = 0; i < products.length; i++) {
      if (products[i] && products[i].id) {
        seed = products[i];
        break;
      }
    }

    if (!seed) {
      if (section) section.hidden = true;
      return;
    }

    /* Removing an item can promote a new newest — but re-fetching for the same
       seed would only redraw what is already on screen. */
    if (host.dataset.productId === String(seed.id)) {
      if (section) section.hidden = false;
      return;
    }

    host.dataset.productId = String(seed.id);
    if (section) section.hidden = false;
    host.initializeRecommendations(String(seed.id));
  }

  function hideRecommendations() {
    var section = document.querySelector('[data-fi-wishlist-recommendations]');
    if (section) section.hidden = true;
  }

  function renderGrid() {
    var grid = document.querySelector('[data-fi-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-fi-wishlist-empty]');
    var items = read();

    if (!items.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      hideRecommendations();
      return;
    }

    grid.hidden = false;
    if (empty) empty.hidden = true;

    var requests = items.map(function (item) {
      return window
        .fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
          headers: { Accept: 'application/json' }
        })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(requests).then(function (products) {
      var fragment = document.createDocumentFragment();
      var missing = [];

      products.forEach(function (product, index) {
        /* Unpublished or deleted products are dropped rather than shown broken. */
        if (!product || !product.variants) {
          missing.push(items[index].handle);
          return;
        }
        fragment.appendChild(card(product, grid));
      });

      grid.innerHTML = '';
      grid.appendChild(fragment);

      seedRecommendations(products);

      if (missing.length) {
        write(
          read().filter(function (item) {
            return missing.indexOf(item.handle) === -1;
          })
        );
      }
    });
  }

  /* ---------- wiring ---------- */

  function paint() {
    paintButtons();
    paintCount();
  }

  window.FIWishlist.subscribe(function () {
    paint();
    renderGrid();
  });

  /* Another tab changed the list. */
  window.addEventListener('storage', function (event) {
    if (event.key && event.key !== KEY) return;
    paint();
    renderGrid();
  });

  function boot() {
    paint();
    renderGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Section rendering (variant swaps, customiser edits) re-inserts the buttons. */
  document.addEventListener('shopify:section:load', paint);
})();
